/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- SECTION LOADER : STYLES --------------- ++++++++++ */
export default theme => ({
  content: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    borderRadius: '4px',
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    padding: '16px 26px',
    marginTop: '1rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // fontFamily: '"Open Sans",sans-serif', // Not sure if we want to leave this as works sans or include Open Sans just for this preview.
    maxWidth: '100%',
    '& span.icon': {
      paddingRight: '16px',
      fontSize: '14px',
      alignSelf: 'baseline',
      '& path': {
        stroke: '#000'
      }
    },
    '& span.text': {
      verticalAlign: 'middle',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '140%',
      color: 'rgba(0,0,0,1)'
    },
    '& a': {
      color: 'rgba(6,18,64,1)',
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    '& h1, h2, h3, h4, h5, h6': {
      display: 'inline-block',
      fontWeight: 'bold',
      margin: '0',
      color: 'rgba(0, 0, 0, 1)',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '& h1': {
      fontSize: '2em',
      lineHeight: '2em'
    },
    '& h2': {
      fontSize: '1.5em',
      lineHeight: '1.5em'
    },
    '& h3': {
      fontSize: '1.17em',
      lineHeight: '1.2em'
    },
    '& h4': {
      fontSize: '1em',
      lineHeight: '1.2em'
    },
    '& h5': {
      fontSize: '.83em',
      lineHeight: '1.2em'
    },
    '& h6': {
      fontSize: '.67em',
      lineHeight: '1.2em'
    },
    '& b': {
      fontWeight: 700
    },
    '& i': {
      fontStyle: 'italic'
    },
   '& .markdownpreview-v2': {
    width: '100%',
    '& .heading': {
      fontWeight: 700,
      display: 'block',
      marginBottom: '1em'
    },
    '& svg': {
      backgroundColor: '#E8EBF7',
      width: '28px',
      height: '28px',
      border: '4px solid #E8EBF7',
      borderRadius: '100%'
    }
   }
  }
});
